import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { PlanAniosComponent } from './components/plan-anios/plan-anios.component';
import { AniosComponent } from './components/anios/anios.component';
import { EquipoGerencialComponent } from './components/equipo-gerencial/equipo-gerencial.component';
import { PlanInstitucionalComponent } from './components/plan-institucional/plan-institucional.component';
import { AreaComponent } from './components/area/area.component';
import { ConstantsCatalogosIdService } from 'src/app/services/constants-catalogos-id.service';
import { AccessPermisionGuard } from 'src/app/guard/accessPermision.guard';



const routesCatalogoAdmin: Routes = [
  {
    path: '',
    //component: PagesComponent,//Ruta protegida: En PagesComponent se renderiza todo lo de estas rutas de abajo
    //canActivate:[AuthGuard],
    children:
    [
      { path: 'areas', component: AreaComponent , data:{title:'Areas', apps:[ConstantsCatalogosIdService.AREAS]}, canActivate:[AccessPermisionGuard]},
      { path: 'plan-institucional', component: PlanInstitucionalComponent, data:{title:'Plan Institucional', apps:[ConstantsCatalogosIdService.PLAN_INSTITUCIONAL]}, canActivate:[AccessPermisionGuard]},
      { path: 'plan-anios', component: PlanAniosComponent, data:{title:'Plan Anios', apps:[ConstantsCatalogosIdService.PLAN_ANIOS]}, canActivate:[AccessPermisionGuard]},
      { path: 'anios', component: AniosComponent, data:{title:'Anios', apps:[ConstantsCatalogosIdService.ANIOS]}, canActivate:[AccessPermisionGuard]},
      { path: 'equipo-gerencial', component: EquipoGerencialComponent, data:{title:'Equipo Gerencial' , apps:[ConstantsCatalogosIdService.PARTICIPANTES_ELEMENTOS]}, canActivate:[AccessPermisionGuard]},
    ]
  },//Para rutas protegidas
];

@NgModule({
 imports: [RouterModule.forChild(routesCatalogoAdmin)],//Para rutas hijas
  exports: [RouterModule]



})

export class CatalogosRoutingAdminModule { }
